app.factory('referralToClinicModel', ['$rootScope', 'baseModel', 'referralToClinicService',
    function($rootScope, baseModel, referralToClinicService) {

        function ReferralToClinicModel() {

            this.save = function(data) {
                return referralToClinicService.save(data).then(
                    function (response) {
                        $rootScope.$broadcast(Event.REFERRAL_TO_CLINIC.SAVE.SUCCESS, response);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.REFERRAL_TO_CLINIC.SAVE.ERROR, error);
                        $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.MEEDY.SYSTEM.NOTIFICATION.OPERATION_FAILED'));
                    }
                );
            };

            this.getPDF = function(id) {
                return referralToClinicService.getPDF(id).then(
                    function (response) {
                        $rootScope.$broadcast(Event.REFERRAL_TO_CLINIC.GET_PDF.SUCCESS, response);

                        return response;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.REFERRAL_TO_CLINIC.GET_PDF.ERROR, error);
                        $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.MEEDY.SYSTEM.NOTIFICATION.OPERATION_FAILED'));
                    }
                );
            };

            this.delete = function(id) {
                return referralToClinicService.delete(id).then(
                    function (response) {
                        $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.SUCCESS, 'T.MEEDY.SYSTEM.NOTIFICATION.OPERATION_SUCCEEDED'));
                        return response;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.MEEDY.SYSTEM.NOTIFICATION.OPERATION_FAILED'));
                    }
                );
            };
        }

        return new ReferralToClinicModel();
    }
]);
